import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as appConstants from "../../../constants/appConstants";
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as localStorage from '../../../localStorage/localStorage';
import Player from '@vimeo/player';
import * as animationHelper from "../../../helpers/animationHelper";

const MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;

class VimeoVideoInline extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            video: this.props.video,
            locale: appHelper.getLocalData(this.props.screenObject),
            responseData: {
                latestResponse: {}
            },
            player: {},
            isPlaying: false,
            initialised: false,
            status: objectConstants.STATUS_NOT_STARTED,
            trackable: true,
            autoplay: false,
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            initialise: false,
            muted: true,
            time: {
                seconds: 0,
                percents: 0,
                duration: 0,
            },
            play_label: appHelper.getLocaleString("play_label"),
            replay_label: appHelper.getLocaleString("replay_label"),
            pause_label: appHelper.getLocaleString("pause_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            hideContinueAfterPressed: appHelper.isDefined(props.hideContinueAfterPressed) ? props.hideContinueAfterPressed : false,
            continuePressed: false,

        };

        this.initVideoPlayer = this.initVideoPlayer.bind(this);
        this.show = this.show.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.onEndedFunc = this.onEndedFunc.bind(this);
        this.onPauseFunc = this.onPauseFunc.bind(this);
        this.onPlayFunc = this.onPlayFunc.bind(this);
        this.onVideoMessage = this.onVideoMessage.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.getVimeoId = this.getVimeoId.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.customPlay = this.customPlay.bind(this);
        this.customPause = this.customPause.bind(this);
        this.getControlClass = this.getControlClass.bind(this);
        this.setStatusClass = this.setStatusClass.bind(this);
        this.reInit = this.reInit.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.updateTime = this.updateTime.bind(this);
        this.onComplete = this.onComplete.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        this.getObjectStatus();
        this.show();
        this.initVideoPlayer();
        window.addEventListener('message', this.onVideoMessage, false);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.screenObject.asset_id !== nextProps.screenObject.asset_id) {
            this.setState({
                screenObject: Object.assign({}, nextProps.screenObject),
                video: Object.assign({}, nextProps.video),
                initialise: true
            });
        }
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData)
            });
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                play_label: appHelper.getLocaleString("play_label"),
                replay_label: appHelper.getLocaleString("replay_label"),
                pause_label: appHelper.getLocaleString("pause_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
            });
        }
    }

    componentDidUpdate() {
        if (appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && !this.state.initialised && this.state.video.src.length > 0) {
            this.initVideoPlayer();
        }
        if (this.state.initialise) {

            this.reInit();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onVideoMessage, false);
    }

    reInit() {
        this.setState({
            initialise: false,
            locale: appHelper.getLocalData(this.state.screenObject),
            isPlaying: false,
        });


        this.getObjectStatus();
        // this.show();
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screenObject);
        this.setState({locale: Object.assign({}, locale)});
        if (this.state.screenObject.show_title_in_header) {
            this.props.actions.setScreenTitle(locale.title);
        }
    }

    getObjectStatus() {

    }


    initVideoPlayer() {
        let videoId = this.getVimeoId(this.state.video.src);

        const player = new Player(`video_${this.state.screenObject.asset_id}`, {
            id: parseFloat(videoId),
            width: '100%',
            height: 'auto'
        });

        let updateTime = this.updateTime;

        player.on('play', function () {
            player.mute = false;
            player.setVolume(1);
            //player.pause();
            //player.play();
        });

        player.on('pause', function () {
        });

        player.on('ended', function () {

        });

        player.on('loaded', function () {
        });


        player.on('timeupdate', function (time) {
            updateTime(time);
        });

        //console.log(`this.state.lang`,this.state.lang)

        player.enableTextTrack(this.state.lang).then(function (track) {
            // track.language = the iso code for the language
            // track.kind = 'captions' or 'subtitles'
            // track.label = the human-readable label
        }).catch(function (error) {
            switch (error.name) {
                case 'InvalidTrackLanguageError':
                    // no track was available with the specified language
                    break;

                case 'InvalidTrackError':
                    // no track was available with the specified language and kind
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });


        this.setState({
            initialised: true,
            player: player,
        });
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    updateTime(time) {
        this.setState({time: time});
    }

    onVideoMessage(e) {
        if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
        const data = e.data;
        if (data.event === 'play') this.onPlayFunc();
        if (data.event === 'pause') this.onPauseFunc();
        if (data.event === 'ended') this.onEndedFunc();
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: false
        };

        this.props.callbacks.onObjectComplete(completionData);
    }

    onEndedFunc(event) {
        //if (this.state.status !== objectConstants.STATUS_COMPLETE) {
        this.handleProgression();
        //}
        //this.setState({isPlaying: false});
        this.setState({status: objectConstants.STATUS_COMPLETE});
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoPlayed(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    onPauseFunc(event) {
        this.state.player.pause();
        this.setState({isPlaying: false});
    }

    onPlayFunc(event) {

        this.props.callbacks.scrollToVideo();
        this.setState({isPlaying: true});
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_IN_PROGRESS});
        }
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    setClass() {
        if (this.state.isPlaying) {
            return "playing";
        } else {
            return "";
        }
    }

    setStatusClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "viewed";
        } else {
            return "not-viewed";
        }

    }

    show() {
        let objectRef = this.objectRef.current;
        if (appHelper.isEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.fadeIn(params);
        }
    }

    getVimeoId(src) {

        return src.split('.com/').pop().toLowerCase();

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    customPlay() {
        this.setState({isPlaying: true});
        this.state.player.play();

        this.props.callbacks.scrollToVideo();
    }

    customPause() {
        this.setState({isPlaying: true});
        this.state.player.pause();
    }

    getControlClass() {
        return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
    }

    setKeyboardAccessibility(event) {
        if (appHelper.isDefined(event)) {
            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
                event.preventDefault();
                this.customPlay();
            }
        }
    }

    onComplete(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({continuePressed: true});
        let hasNextObject = this.props.callbacks.hasNextObject(this.state.screenObject);
        if (hasNextObject) {
            let nextObject = this.props.callbacks.getNextScreenObject(this.state.screenObject);
            this.props.callbacks.getObject(nextObject);
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    render() {

        return (

            <div className="object-container" ref={this.objectRef}>
                <div className={`video-object`}>
                    <div className="video-wrapper" onClick={this.customPlay}
                         onKeyDown={this.setKeyboardAccessibility}
                         role="link" tabIndex="0">
                        <div
                            data-vimeo-url={`https://player.vimeo.com/video/${this.getVimeoId(this.state.video.src)}`}
                            data-vimeo-autoplay={this.state.autoplay}
                            id={`video_${this.state.screenObject.asset_id}`}
                            data-vimeo-muted="muted"
                        />
                    </div>

                    <div className="video-details">
                        <div className="video-title-panel">
                            <div>
                                {
                                    this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                        ?
                                        <h4 className={`heading-4 ${this.setStatusClass()}`}
                                            dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                        :
                                        null
                                }
                            </div>

                            <div>
                                {
                                    this.state.status === objectConstants.STATUS_COMPLETE && (!this.state.hideContinueAfterPressed || (this.state.hideContinueAfterPressed && !this.state.continuePressed))
                                        ?
                                        <button className={`btn guroo-btn`}
                                                onClick={this.onComplete}>{this.state.continue_label}</button>
                                        :
                                        null

                                }
                            </div>


                        </div>

                        {
                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description.length > 0
                                ?
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                :
                                null
                        }
                    </div>

                </div>
            </div>

        );
    }
}

VimeoVideoInline.propTypes = {
    screenObject: PropTypes.object.isRequired,
    video: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    autoPlay: PropTypes.bool.isRequired,
    hideContinueAfterPressed: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

VimeoVideoInline.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VimeoVideoInline);



/** WEBPACK FOOTER **
 ** ./src/components/objects/video/VimeoPlayer.js
 **/